import { render, staticRenderFns } from "./HomeSLider.vue?vue&type=template&id=db272252&scoped=true&"
import script from "./HomeSLider.vue?vue&type=script&lang=js&"
export * from "./HomeSLider.vue?vue&type=script&lang=js&"
import style0 from "./HomeSLider.vue?vue&type=style&index=0&id=db272252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db272252",
  null
  
)

export default component.exports